export default "__VITE_ASSET__F_Wb3Qc1__"